// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ShortcutsPanel__buttonPanel___Fl9nP {
    display: flex;
    justify-content: end;
}

.ShortcutsPanel__content___voUh7 {
    width: 32rem;
    padding: var(--space-s);

    background-color: var(--color-bg-default);
    border: var(--control-border-width) solid var(--color-bg-border);
    border-radius: calc(2 * var(--control-radius));
}

.ShortcutsPanel__terms___u8_pg {
    display: grid;
    grid-template-columns: 16.5rem auto;
    row-gap: var(--space-xs);
    align-items: center;
}

.ShortcutsPanel__header___p700e {
    display: flex;
    justify-content: space-between;
    margin-bottom: var(--space-s);
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/components/ShortcutsPanel/ShortcutsPanel.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,uBAAuB;;IAEvB,yCAAyC;IACzC,gEAAgE;IAChE,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,mCAAmC;IACnC,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,6BAA6B;AACjC","sourcesContent":[".buttonPanel {\n    display: flex;\n    justify-content: end;\n}\n\n.content {\n    width: 32rem;\n    padding: var(--space-s);\n\n    background-color: var(--color-bg-default);\n    border: var(--control-border-width) solid var(--color-bg-border);\n    border-radius: calc(2 * var(--control-radius));\n}\n\n.terms {\n    display: grid;\n    grid-template-columns: 16.5rem auto;\n    row-gap: var(--space-xs);\n    align-items: center;\n}\n\n.header {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: var(--space-s);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonPanel": `ShortcutsPanel__buttonPanel___Fl9nP`,
	"content": `ShortcutsPanel__content___voUh7`,
	"terms": `ShortcutsPanel__terms___u8_pg`,
	"header": `ShortcutsPanel__header___p700e`
};
export default ___CSS_LOADER_EXPORT___;
